import { Entry } from '../Entry'

export function Entry20230629() {
  return (
    <Entry title="Jun 29 2023 - v3.4.4">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13904/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
